import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-arrow-dropdown",
  "use": "spr-arrow-dropdown-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 30 30\" id=\"spr-arrow-dropdown\">\r\n<g id=\"spr-arrow-dropdown_Group-2\" transform=\"translate(15.000000, 18.000000) scale(1, -1) rotate(-270.000000) translate(-15.000000, -18.000000) translate(6.000000, 9.000000)\">\r\n\t<path id=\"spr-arrow-dropdown_Combined-Shape\" d=\"M9.3,9l7.1-7.1L15,0.5L7.9,7.6L6.5,9l8.5,8.5l1.4-1.4L9.3,9z\" />\r\n</g>\r\n<path d=\"M15,0c8.3,0,15,6.7,15,15s-6.7,15-15,15S0,23.3,0,15S6.7,0,15,0z M15,28c7.2,0,13-5.8,13-13S22.2,2,15,2S2,7.8,2,15\r\n\tS7.8,28,15,28z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/arrow-dropdown.svg
// module id = 133
// module chunks = 0